// https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits
export const pageview = (url) => {
  window.ga && window.ga('send', 'pageview', url);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageview',
    page: url,
  });
};
